export default {
  trainingCourseDetail_image_text: 'Graphic',
  trainingCourseDetail_blend: 'Mixed',
  trainingCourseDetail_games: 'Game',
  trainingCourseDetail_vedio: 'Video',
  trainingCourseDetail_audio: 'Audio',
  trainingCourseDetail_e_books: 'E-book',
  trainingCourseDetail_not_completed: 'All the punching verification of this courseware has not been completed yet ',
  trainingCourseDetail_continue_punch: 'Please continue to learn to complete the punching',
  trainingCourseDetail_clock_progress: 'Punching progress',
  trainingCourseDetail_continue_learn: 'Continue learning',
  trainingCourseDetail_learned_rules01: 'Learned conditions: The complete content has been learned for at least {ruleValue} minutes',
  trainingCourseDetail_learned_rules02: 'Note: For the courseware with exams, if you have not learned for {ruleValue} minutes, the course will not be marked as learned even if you have passed the exam. You need to learn at least {ruleValue} minutes and then take the exam again.',
  trainingCourseDetail_exit_Course: 'Quit learning',
  trainingCourseDetail_book_title_mark1: "'",
  trainingCourseDetail_book_title_mark2: "'",
  trainingCourseDetail_Learn_now: 'Learn now',
  trainingCourseDetail_Learn_precess: '{processValue}% learned',
}
